import { Price } from '@evermile/api';

export function FormatPrice(price?: Price): string {
  if (!price) return '';

  // Get the value in standard decimal format (value is in cents/pence)
  const value = price.value / 100;

  // Map of currency codes to their symbols
  const currencySymbols: { [key: string]: string } = {
    GBP: '£',
    USD: '$',
    EUR: '€',
    // Add more currencies as needed
  };

  // Get the currency symbol (default to currency code if symbol not found)
  const symbol = currencySymbols[price.currency] || price.currency;

  // Format value with 2 decimal places and add currency symbol
  return `${symbol}${value.toFixed(2)}`;
}
